import ManageJobModal from './ManageJobModal'

export default ManageJobModal
